import { create } from "zustand";

import { InventoryProduct } from "../../../shared/models/inventoryProduct/types";

export type BbdCorrectionPhase =
  | "idle"
  | "resolvingProducts"
  | "search"
  | "searchLoading"
  | "selectProduct"
  | "fetchingBbdTask"
  | "declareBbdCorrection"
  | "notBbdProduct"
  | "hasOpenTask"
  | "declareBbdCorrectionLoading"
  | "declareBbdCorrectionDone";

export type BbdCorrectionState = {
  phase: BbdCorrectionPhase;
  selectedInventoryProductSku: string | null;
  selectedInventoryProductShelf: string | null;
  inventoryProductsList: InventoryProduct[];
  isFromSearch: boolean;
};

type BbdCorrectionActions = {
  enterIdle: () => void;
  setPhase: (phase: BbdCorrectionPhase) => void;
  setInventoryProductsList: (products: InventoryProduct[]) => void;
  resetInventoryProductsList: () => void;
  setInventoryProduct: (sku: string, shelf: string | null) => void;
  setFirstInventoryProductAsSelected: () => void;
  setIsFromSearch: (value: boolean) => void;
  reset: () => void;
};

export const initialState: BbdCorrectionState = {
  phase: "idle",
  selectedInventoryProductSku: null,
  selectedInventoryProductShelf: null,
  inventoryProductsList: [],
  isFromSearch: false,
};

export const useBbdCorrectionStore = create<BbdCorrectionState & BbdCorrectionActions>()(
  (set, get) => ({
    ...initialState,

    enterIdle: () => set({ phase: "idle", isFromSearch: false }),
    setPhase: (phase) => set({ phase }),

    setInventoryProductsList: (products) => set({ inventoryProductsList: products }),
    resetInventoryProductsList: () => set({ inventoryProductsList: [] }),

    setInventoryProduct: (sku, shelf) =>
      set({ selectedInventoryProductSku: sku, selectedInventoryProductShelf: shelf }),

    setFirstInventoryProductAsSelected: () => {
      const first = get().inventoryProductsList[0];
      if (first) {
        set({
          selectedInventoryProductSku: first.productSku,
          selectedInventoryProductShelf: first.shelf,
        });
      }
    },

    setIsFromSearch: (value) => set({ isFromSearch: value }),

    reset: () => set(initialState),
  }),
);
